module.exports = __webpack_public_path__ + "static/media/RA-QC1701L_01.d87cb3bc.png";